import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './branding.css'

const Branding = (props) => {
  return (
    <div className={`branding-branding ${props.rootClassName} `}>
      <span className="branding-text1">
        {props.text21 ?? (
          <Fragment>
            <span className="branding-text4">Abhishek Palit  </span>
          </Fragment>
        )}
      </span>
      <span className="branding-text2">
        {props.text31 ?? (
          <Fragment>
            <span className="branding-text3">
              Architecture, Technology &amp; Sustainability
            </span>
          </Fragment>
        )}
      </span>
    </div>
  )
}

Branding.defaultProps = {
  rootClassName: '',
  text31: undefined,
  text21: undefined,
}

Branding.propTypes = {
  rootClassName: PropTypes.string,
  text31: PropTypes.element,
  text21: PropTypes.element,
}

export default Branding
